import React, { useState } from "react";
import { useTable, useFilters, useSortBy, usePagination } from "react-table";
import SearchIcon from "@mui/icons-material/Search";
import "./styles.css";
import {
  Grid,
  Typography,
  TextField,
  FormControl,
  Button,
  Select,
  InputLabel,
  MenuItem,
} from "@mui/material";
import { useEffect } from "react";

const classes = {
  margin: "4px",
  minWidth: "80px",
  minHeight: "10px",
};

/* Captura a largura da página */
const width_page = window.innerWidth;

/* Define o tamanho padrão como 9 */
let MAX_ITEMS = 5;

/* Definie o número de itens exibidos na páginação dependendo do tamanho da página */
if (width_page < 500) {
  MAX_ITEMS = 1;
}

const MAX_LEFT = (MAX_ITEMS - 1) / 2;

export default function Table({
  columns,
  data,
  searchBy = "reference",
  label = "Pesquise uma ocorrência",
  fixedPageSize = false,
  hideSearch = false,
  hidePagination = false,
  total = 0,
}) {
  const [valueInputSearch, setValueInputSearch] = useState("");

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    pageOptions,
    gotoPage,
    setPageSize,
    setFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0 },
    },
    useFilters,
    useSortBy,
    usePagination
  );

  useEffect(() => {
    if (fixedPageSize && isFinite(fixedPageSize)) setPageSize(fixedPageSize);
  }, [fixedPageSize]);

  /* Sem paginação todas as linhas são exibidas de uma só vez */
  useEffect(() => {
    if (hidePagination) setPageSize(Math.max(data?.length || 0, 1));
  }, [hidePagination, data]);

  const pages = Math.max(pageOptions.length, 1);
  const first = Math.max(pageIndex + 1 - MAX_LEFT, 1);

  // Update the state when input changes
  const handleFilterChange = (e) => {
    const value = e || undefined;
    setFilter(searchBy, value); // Update the show.name filter. Now our table will filter and show only the page which have a matching value
  };

  return (
    <div style={{ marginTop: 30 }}>
      {hideSearch ? (
        false
      ) : (
        <>
          <Grid container spacing={1} id="table-occurrences-input">
            <Grid item xs={9} sm={10} md={10} lg={11} xl={11}>
              <TextField
                style={{ backgroundColor: "white" }}
                fullWidth
                label={label}
                size="small"
                onChange={(e) => setValueInputSearch(e.target.value)}
              />
            </Grid>

            <Grid item xs={3} sm={2} md={2} lg={1} xl={1}>
              <Button
                fullWidth
                variant="outlined"
                type="button"
                style={{ height: 40, backgroundColor: "#155BCB" }}
                onClick={() => {
                  handleFilterChange(valueInputSearch);
                }}
              >
                <SearchIcon style={{ color: "#fff" }} />
              </Button>
            </Grid>
          </Grid>

          <br />
        </>
      )}

      <div>
        <div
          className="table-component"
          style={{
            overflowX: "auto",
            overflowY: "hidden",
          }}
        >
          <table
            id="table-occurrences"
            style={{ width: "100%" }}
            {...getTableProps()}
          >
            <thead>
              {headerGroups.map((headerGroup) => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map((column) => (
                    <th
                      {...column.getHeaderProps(column.getSortByToggleProps())}
                      className={
                        column.isSorted
                          ? column.isSortedDesc
                            ? "sort-desc"
                            : "sort-asc"
                          : ""
                      }
                    >
                      {column.render("Header")}
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody
              {...getTableBodyProps()}
              style={{ backgroundColor: "white", borderRadius: 10 }}
            >
              {page.map((row, i) => {
                prepareRow(row);
                return (
                  <tr {...row.getRowProps()}>
                    {row.cells.map((cell) => {
                      return (
                        <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        {hidePagination ? (
          false
        ) : (
        <Grid
          container
          className="pagination-table"
          style={{ marginTop: 50, width: "100%" }}
          alignItems="center"
          spacing={2}
          justifyContent="flex-end"
        >
          {fixedPageSize ? (
            false
          ) : (
            <Grid item xs={12} sm={9} md={4} lg={3} style={{ margin: "auto" }}>
              <FormControl
                variant="outlined"
                fullWidth
                size="small"
                className={classes.formControl}
              >
                <InputLabel id="Número de linhas: ">
                  Número de linhas:
                </InputLabel>

                <Select
                  onChange={(e) => {
                    setPageSize(Number(e.target.value));
                  }}
                  variant="outlined"
                  label="Número de linhas: "
                  labelId="Número de linhas: "
                  value={pageSize}
                  style={{ background: "#fff" }}
                >
                  {[10, 20, 30, 40, 50].map((pageSize) => (
                    <MenuItem key={pageSize} value={pageSize}>
                      {pageSize}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          )}

          <Grid
            container
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            justifyContent="center"
            spacing={2}
          >
            <ul className="pagination">
              <li>
                <button
                  onClick={() => gotoPage(pageIndex - 1)}
                  disabled={pageIndex === 0}
                >
                  Anterior
                </button>
              </li>

              {Array.from({ length: Math.min(MAX_ITEMS, pages) })
                .map((_, index) => index + first)
                .map((page) => (
                  <li key={page}>
                    <button
                      onClick={() => gotoPage(page - 1)}
                      className={
                        page - 1 === pageIndex
                          ? "pagination__item--active"
                          : null
                      }
                      disabled={pages < page}
                    >
                      {page}
                    </button>
                  </li>
                ))}

              <li>
                <button
                  onClick={() => gotoPage(pageIndex + 1)}
                  disabled={pageIndex + 1 === pages}
                >
                  Próxima
                </button>
              </li>
            </ul>
          </Grid>
        </Grid>
        )}

        {hidePagination ? (
          false
        ) : (
          <div
            style={{
              width: "100%",
              textAlign: "center",
              marginTop: 20,
              color: "#1351B4",
              fontWeight: 500,
            }}
          >
            Total de registros encontrados: {data?.length || 0}
          </div>
        )}
      </div>
    </div>
  );
}
